// ============================================================
// TIMESTAMP UTILITY - Firestore timestamp conversion
// ============================================================

export interface FirestoreTimestamp {
  toMillis?: () => number;
  seconds?: number;
}

/**
 * Converts a Firestore Timestamp (or plain number) to milliseconds.
 * Firestore returns Timestamp objects, not numbers - this normalizes them.
 */
export function toMs(t: FirestoreTimestamp | number | null | undefined): number {
  if (!t) return 0;
  if (typeof t === 'number') return t;
  if (typeof t === 'object') {
    if (typeof t.toMillis === 'function') return t.toMillis();
    if (typeof t.seconds === 'number') return t.seconds * 1000;
  }
  return 0;
}
